import { render, staticRenderFns } from "./DiamondEdition.vue?vue&type=template&id=ff2c4026&scoped=true&"
import script from "./DiamondEdition.vue?vue&type=script&lang=js&"
export * from "./DiamondEdition.vue?vue&type=script&lang=js&"
import style0 from "./DiamondEdition.vue?vue&type=style&index=0&id=ff2c4026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2c4026",
  null
  
)

export default component.exports